import React, { useEffect, useState, ChangeEvent } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Tooltip,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Heading,
  VStack,
  HStack,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  useToast,
  Switch,
  Stack,
  Tag,
} from "@chakra-ui/react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Users.css";
import { useAppContext } from "../../../context/AppContext";
import { useMsal } from "@azure/msal-react";
import { userRoles, renderLicenseIcon, getLicenseColor } from "./UserRoleEnum"; // Import enum
import {
  fetchUsers,
  addUser,
  updateUser,
  deleteUserById,
} from "../../../services/AdminServices/Users";
import { User } from "../../../models/user";
import UserLicenceManage from "./UserLicenceManager";

// import TenantList from "./UserLicenseAccess";
const Users: React.FC = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [Office365MailId, setOffice365MailId] = useState("");
  const [dropBoxMailId, setDropBoxMailId] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [licenseType, setLicenseType] = useState<number | null>(null);
  const [users, setUsers] = useState<User[]>([]); // Use typed state
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditing, setIsEditing] = useState<number | null>(null);
  const [userId, setuserId] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [itemsPerPage, setItemsPerPage] = useState(10); // Items per page
  const [username, setUserName] = useState("");

  const toast = useToast();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);

  // api integration
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { accessToken, userData } = useAppContext();

  // tenant id

  const validateEmail = (Office365MailId: string): boolean => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(Office365MailId);
  };

  const [selectedUserRole, setSelectedUserRole] = useState<string>("");

  // Update the handleRoleChange function to specify the type of the event parameter
  const handleRoleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setSelectedUserRole(event.target.value);
  };

  // Handle Office365 email change
  const handleOffice365EmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setOffice365MailId(value);

    // Only sync to DropBox email if not in edit mode
    if (!isEditing) {
      setDropBoxMailId(value);
    }
  };

  // Handle DropBox email change
  const handleDropBoxEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDropBoxMailId(e.target.value);
  };

  const tenantID = userData?.tenantID || 0;
  const [isManageLicenseOpen, setIsManageLicenseOpen] = useState(false);
  const [selectedLicenseUser, setSelectedLicenseUser] = useState<User | null>(
    null
  );

  const openManageLicenseModal = (userLicence?: User) => {
    setSelectedLicenseUser(userLicence || null);
    setIsManageLicenseOpen(true);
  };

  const closeManageLicenseModal = () => {
    setIsManageLicenseOpen(false);
    setSelectedLicenseUser(null);
  };

  const handleManageLicenseSave = () => {
    // Logic to refresh or update the data after saving
    getUsers();
    closeManageLicenseModal();
  };

  const handleSave = async () => {
    
    if (!firstName.trim() || !lastName.trim() || !selectedUserRole) {
      toast({
        position: "top",
        title: "Required Fields Missing",
        description:
          "Please fill in all required fields: First Name, Last Name, and User Role.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!validateEmail(Office365MailId)) {
      toast({
        position: "top",
        title: "Enter valid email",
        description: "Please provide a valid email address.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Validate DropBox email if provided
    if (dropBoxMailId && !validateEmail(dropBoxMailId)) {
      toast({
        position: "top",
        title: "Enter valid DropBox email",
        description: "Please provide a valid DropBox email address.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    setError(null);

    const userPayload = {
      firstName,
      lastName,
      Office365MailId,
      dropBoxMailId,
      username: `${firstName} ${lastName}`,
      roleID:
        userRoles.find((role) => role.value === Number(selectedUserRole))
          ?.value || 0,
      isActive,
      createdBy: userData?.userID,
    };

    try {
      if (isEditing !== null) {
        // Update logic
        // const userID = users[isEditing].userID;

        const updatedUser = {
          ...userPayload,
          UserID: userId,
          updatedBy: userData?.userID,
        };

        await updateUser(updatedUser, accessToken, tenantID);

        // await fetchUsers()

        // setUsers((prevUsers) =>
        //   prevUsers.map((user, index) =>
        //     index === isEditing ? { ...user, ...userPayload } : user
        //   )
        // );

        toast({
          position: "top",
          title: "User Updated",
          description: `${firstName} has been updated successfully.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        // location.reload();
      } else {
        
        // Add logic
        const createdUser = await addUser(userPayload, accessToken, tenantID);
        setUsers((prevUsers) => [...prevUsers, createdUser]);
        toast({
          position: "top",
          title: "User Added",
          description: `${firstName} has been added successfully.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
      getUsers();
    } catch (error) {
      toast({
        position: "top",
        title: "Error",
        description: "An unexpected error occurred.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      setError("Failed to save user.");
    } finally {
      setLoading(false);
      handleReset();
      onClose();
    }
  };

  const handleReset = () => {
    setFirstName("");
    setLastName("");
    setOffice365MailId("");
    setDropBoxMailId("");
    setSelectedUserRole("");
    setIsActive(true);
    setIsEditing(null);
  };

  const handleClose = () => {
    handleReset(); // Reset the form fields
    setIsEditing(null); // Reset edit mode
    onClose(); // Close the modal
  };

  const handleEdit = (data: any) => {
    setFirstName(data.firstName);
    setLastName(data.lastName);
    setOffice365MailId(data.Office365MailId);
    setDropBoxMailId(data.dropBoxMailId || "");
    setUserName(`${data.firstName} ${data.lastName}`);
    // setUserRole(userToEdit.roleID || "");
    setSelectedUserRole(data.roleID ? data.roleID.toString() : "");
    setIsActive(data.isActive);
    setuserId(data.userID);
    // Store the full global index in the isEditing state to know which user to update
    setIsEditing(data.userID);
    onOpen(); // Open the modal for editing
  };

  const openDeleteModal = (userId: number) => {
    setDeleteIndex(userId);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteIndex(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    if (deleteIndex !== null) {
      const UserIdforDelete = deleteIndex;
      console.log("Deleting id = ", UserIdforDelete);
      await deleteUser(UserIdforDelete.toString());
    }
    closeDeleteModal();
  };

  const deleteUser = async (UserId: string | null) => {
    if (!UserId) {
      toast({
        position: "top",
        title: "Error",
        description: "Invalid user ID. Cannot delete user.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!accessToken) {
      toast({
        position: "top",
        title: "Error",
        description: "Authorization failed. Access token is missing.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!userData || typeof userData.userID !== "number") {
      toast({
        position: "top",
        title: "Error",
        description: "User context is missing. Cannot delete user.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await deleteUserById(
        UserId,
        accessToken,
        tenantID,
        userData.userID
      );

      if (typeof response === "string") {
        console.log(response);
      }

      toast({
        position: "top",
        title: "User Deleted",
        description: "The user has been deleted successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      getUsers(); // Refresh user list
    } catch (error: any) {
      console.error("Delete Error:", error);
      setError("Failed to delete user.");
      toast({
        position: "top",
        title: "Error",
        description: error.message || "An unexpected error occurred",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleItemsPerPageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to the first page when items per page changes
  };

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // Filter the sites based on the search query
  const filteredSites = users.filter((site) =>
    site.Office365MailId?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination Logic
  const totalSites = filteredSites.length;
  const totalPages = Math.ceil(totalSites / itemsPerPage);
  const indexOfLastSite = currentPage * itemsPerPage;
  const indexOfFirstSite = indexOfLastSite - itemsPerPage;
  const currentSites = filteredSites.slice(indexOfFirstSite, indexOfLastSite);

  const getUsers = async () => {
    try {
      if (accessToken) {
        var tenantid = userData?.tenantID;
        // Check if accessToken is not null
        const data = await fetchUsers(accessToken, tenantid!);
        setUsers(data);
        console.log("Users data :>>>>> ", data);
      } else {
        setError("Access token is missing.");
      }
    } catch (error) {
      setError("Failed to fetch users.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []); // Fetch data when accessToken changes

  useEffect(() => {
    // Reset to first page when search term changes
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <Flex justify="space-between" align="center" mb={4} p={6}>
        <Heading as="h2">Users</Heading>

        <Button colorScheme="blue" onClick={onOpen}>
          <i className="bi bi-person-plus" style={{ marginRight: "8px" }}></i>
          Add New User
        </Button>
      </Flex>

      <Box
        p={6}
        shadow="md"
        borderWidth="1px"
        borderRadius={"15px"}
        backgroundColor={"#fff"}
      >
        <Flex justify="space-between" align="center" mb={4}>
          <Flex justify="space-between" align="center" mb={4}>
            <Select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              maxWidth="200px"
            >
              <option value={10}>10 items per page</option>
              <option value={20}>20 items per page</option>
              <option value={30}>30 items per page</option>
            </Select>
          </Flex>
          <FormControl mb={4} maxWidth="300px">
            <Input
              placeholder="Search by Email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </FormControl>
        </Flex>
        <Table className="Table">
          <Thead>
            <Tr>
              <Th>FirstName</Th>
              <Th>LastName</Th>
              <Th>office365MailId</Th>
              <Th>DropBox Email</Th>
              <Th>User Role</Th>
              <Th>Status</Th>
              <Th>Licence Type</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {/* Loop of the User */}
            {currentSites.map((user) => (
              <Tr>
                <Td>{user.firstName}</Td>
                <Td>{user.lastName}</Td>
                <Td>{user.Office365MailId}</Td>
                <Td>{user.dropBoxMailId || "-"}</Td>
                <Td>
                  {
                    // Find the label from userRoles array based on roleID (which corresponds to userRole)
                    userRoles.find((role) => role.value === user.roleID)
                      ?.label || "SuperAdmin"
                  }
                </Td>
                <Td>
                  <span
                    className={`status-box ${
                      user.isActive ? "active" : "inactive"
                    }`}
                  >
                    {user.isActive ? "Active" : "Inactive"}
                  </span>
                </Td>
                <Td>
                  {!user.tenantLicenseID ||
                  user.tenantLicenseID === 0 ||
                  user.isUserLicenseRemoved ||
                  !user.IsLicenseActive ? (
                    <Tag colorScheme="gray" size="lg">
                      <i
                        className="bi bi-slash-circle"
                        style={{ marginRight: 6 }}
                      />
                      License not assigned
                    </Tag>
                  ) : (
                    <Flex align="center">
                      {renderLicenseIcon(user.licenceTypeName!)}
                      <Tag
                        ml={2}
                        fontSize="md"
                        fontWeight="medium"
                        colorScheme={getLicenseColor(user.licenceTypeName!)}
                      >
                        {user.licenceTypeName} – {user.title}
                      </Tag>
                    </Flex>
                  )}
                </Td>
                <Td>
                  <Flex>
                    <Tooltip
                      label="Edit User"
                      aria-label="Edit User"
                      placement="top"
                    >
                      <Button
                        size="sm"
                        colorScheme="blue"
                        onClick={() => handleEdit(user)}
                        mr={2}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </Button>
                    </Tooltip>
                    <Tooltip
                      label="Delete User"
                      aria-label="Delete User"
                      placement="top"
                    >
                      <Button
                        size="sm"
                        colorScheme="red"
                        mr={2}
                        onClick={() => openDeleteModal(user.userID)}
                      >
                        <i className="bi bi-trash3"></i>
                      </Button>
                    </Tooltip>
                    <Tooltip
                      label="Manage License"
                      aria-label="Manage License"
                      placement="top"
                    >
                      <Button
                        size="sm"
                        colorScheme="green"
                        onClick={() => openManageLicenseModal(user)}
                      >
                        <i className="bi bi-gear"></i>
                      </Button>
                    </Tooltip>
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        {isLoading && <Text>Loading...</Text>}
        {error && <Text color="red.500">{error}</Text>}

        {/* Page Info */}
        <Flex justify="space-between" mt={4}>
          <Box>
            <span>
              Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
              {Math.min(currentPage * itemsPerPage, totalSites)} of {totalSites}{" "}
              entries
            </span>
          </Box>

          {/* Pagination */}
          <HStack spacing={4}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Previous
            </Button>

            <Select
              value={currentPage}
              onChange={(e) => handlePageChange(Number(e.target.value))}
              maxWidth="70px"
            >
              {Array.from({ length: totalPages }, (_, index) => (
                <option key={index} value={index + 1}>
                  {index + 1}
                </option>
              ))}
            </Select>

            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </HStack>
        </Flex>
      </Box>

      {/* User Licence Manage Modal */}
      {/* <UserLicenceManage
        isManageLicenseOpen={isManageLicenseOpen} // Pass the boolean state here
        onClose={closeManageLicenseModal}
        onSave={handleManageLicenseSave}
        userLicence={selectedLicenseUser} // Make sure to use the correct prop name
      /> */}

      {isManageLicenseOpen && (
        <UserLicenceManage
          isManageLicenseOpen={isManageLicenseOpen}
          onClose={closeManageLicenseModal}
          onSave={handleManageLicenseSave}
          users={users}
          selectedLicenseUser={selectedLicenseUser}
        />
      )}

      {/* <TenantList/> */}

      {/* this is delete model  */}
      <Modal isOpen={isDeleteModalOpen} onClose={closeDeleteModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete User</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {deleteIndex !== null && (
              <Text>
                Are you sure you want to delete the user{" "}
                <strong>
                  "{users.find((a) => a.userID == deleteIndex)?.Office365MailId}
                  "
                </strong>
                ?
              </Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={confirmDelete}>
              Yes, Delete
            </Button>
            <Button variant="ghost" onClick={closeDeleteModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {isEditing !== null ? "Edit User" : "Add New User"}
          </ModalHeader>
          <ModalCloseButton />
          <hr style={{ border: "1px solid #black" }} />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              {/* First Name */}
              <FormControl isRequired>
                <FormLabel>First Name</FormLabel>
                <Input
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="Enter first name"
                />
              </FormControl>

              {/* Last Name */}
              <FormControl isRequired>
                <FormLabel>Last Name</FormLabel>
                <Input
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Enter last name"
                />
              </FormControl>

              {/* Email */}
              <FormControl isRequired>
                <FormLabel>Email</FormLabel>
                <Input
                  value={Office365MailId}
                  onChange={handleOffice365EmailChange}
                  placeholder="Enter email"
                />
              </FormControl>

              {/* DropBox Email */}
              <FormControl>
                <FormLabel>DropBox Email</FormLabel>
                <Input
                  value={dropBoxMailId}
                  onChange={handleDropBoxEmailChange}
                  placeholder="Enter DropBox email"
                />
              </FormControl>

              {/* User Role */}
              <FormControl isRequired>
                <FormLabel>User Role</FormLabel>
                <Select
                  value={selectedUserRole || ""} // Default to empty string for "Select Role"
                  onChange={handleRoleChange}
                  placeholder="Select Role"
                >
                  {userRoles.map((role) => (
                    <option key={role.value} value={role.value}>
                      {role.label}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {/* Active Status */}
              <FormControl>
                <Stack alignItems="left">
                  <FormLabel mb={0}>Status</FormLabel>
                  <Switch
                    isChecked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                    colorScheme="blue"
                  />
                </Stack>
              </FormControl>
            </VStack>
          </ModalBody>
          <hr style={{ border: "1px solid #black" }} />
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleSave} mr={3}>
              {isEditing !== null ? "Update" : "Save"}
            </Button>
            <Button variant="ghost" onClick={handleClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Users;
